/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_Recon_TitleInputs */

const vi_cashflow_recon_title = /** @type {(inputs: Cashflow_Recon_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đối chiếu ngân hàng`)
};

/**

* @param {Cashflow_Recon_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_recon_title = /** @type {((inputs?: Cashflow_Recon_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_Recon_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_recon_title(inputs)
});